module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['social-medias', {
      'social-medias--light': _vm.colorMode == 'light'
    }]
  }, [_c('h4', {
    staticClass: "social-medias__title"
  }, [_vm._v(_vm._s(_vm.$t('getToKnowUs', _vm.lang)))]), _vm._v(" "), _vm._l((_vm.medias), function(media) {
    return _c('a', {
      staticClass: "social-medias__link",
      attrs: {
        "href": media.url,
        "target": "_blank",
        "title": media.title
      },
      domProps: {
        "innerHTML": _vm._s(media.icon)
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11d42da9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialMedias.vue
// module id = 171
// module chunks = 0